import { HeaderV2LayoutAction } from "../../../stores/header-v2-layout-store";
import HeaderV2AiAssistantIconButton from "../../header-v2-icons/ai-assistant/header-v2-ai-assistant-icon-button";
import HeaderV2ChatWithOperatorIcon from "../../header-v2-icons/chat-with-operator/header-v2-chat-with-operator-icon";
import HeaderV2NotificationIcon from "../../header-v2-icons/notifications/header-v2-notification-icon";
import HeaderV2SearchIcon from "../../header-v2-icons/search/header-v2-search-icon";

export function renderHeaderV2ActionIcon(action: HeaderV2LayoutAction): JSX.Element | null {
  switch (action) {
    case HeaderV2LayoutAction.notification:
      return <HeaderV2NotificationIcon key={action} />;
    case HeaderV2LayoutAction.search:
      return <HeaderV2SearchIcon key={action} />;
    case HeaderV2LayoutAction.chatWithOperator:
      return <HeaderV2ChatWithOperatorIcon key={action} />;
    case HeaderV2LayoutAction.aiAssistant:
      return <HeaderV2AiAssistantIconButton key={action} />;
    default:
      return null;
  }
}
